import { ValueObject } from '@nx-smartmonkey/shared/domain';

export type SubscriptionCredentialsItem =
  | `customers`
  | `customers.white_label`
  | `customers.satisfaction`
  | `customers.communication_emails`
  | `customers.communication_sms`
  | `supervisors`
  | `supervisors.white_label`
  | `planner.analytics`
  | `planner.stops`
  | `planner.geofences`
  | `planner.users`
  | `planner.projects`
  | `planner.api`
  | `planner.clients`
  | `planner.tasks`
  | `planner.webhooks`
  | `drivers.advanced_pod`
  | `drivers.pin_confirmation`
  | `drivers.surveys`
  | `drivers.planning`;

export const SubscriptionCredentialItems: SubscriptionCredentialsItem[] = [
  `customers`,
  `customers.white_label`,
  `customers.satisfaction`,
  `customers.communication_emails`,
  `customers.communication_sms`,
  `supervisors`,
  `supervisors.white_label`,
  `planner.analytics`,
  `planner.stops`,
  `planner.geofences`,
  `planner.users`,
  `planner.projects`,
  `planner.api`,
  `planner.clients`,
  `planner.tasks`,
  `planner.webhooks`,
  `drivers.advanced_pod`,
  `drivers.pin_confirmation`,
  `drivers.surveys`,
  `drivers.planning`,
];

interface SubscriptionCredentialsProps {
  active: boolean;
  items: SubscriptionCredentialsItem[];
}

export class SubscriptionCredentials extends ValueObject<SubscriptionCredentialsProps> {
  private constructor(props: SubscriptionCredentialsProps) {
    super(props);
  }

  static create(props: SubscriptionCredentialsProps) {
    return new SubscriptionCredentials(props);
  }

  test(...permissions: SubscriptionCredentialsItem[]) {
    return permissions.every((permission) => this.props.items.includes(permission));
  }

  get isActive(): boolean {
    return this.props.active;
  }

  get items(): SubscriptionCredentialsItem[] {
    return this.props.items;
  }
}
